var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":_vm.$formatId(_vm.slice.id)}})}
var staticRenderFns = []

export { render, staticRenderFns }